$(function() {
  
  
   // how to apply video 
    $('span.apply-video-desktop,span.apply-video-mob').on('click',function(){
                let videoHtml = $('#apply-video-template').html();
                $(this).html(videoHtml);
    });

    // image gallery 
    $('div.cell-play').on('click',function(e){
            e.preventDefault();
           // let videoHtml = $('#gallery-video-template').html();
      var videoHtml = '<video autoplay="true" loop="true" muted="true" preload="auto" playsinline=""><source src="'+$(this).data("video")+'" type="video/mp4" />Your browser does not support our video. </video>';
        $(this).parent().html(videoHtml);
        ga('send', 'event', 'video',location.href, $(this).data("video"));
            $(this).parent().html(videoHtml);

    });
  
  
  
    // show production size guide 
    $(".local--link.js-modal").on('click',function() {
      // let imageHtml = $('#product-option-length-modal');
      // $.fancybox.open(imageHtml); 
      $.fancybox.open({
        href : $('#product-option-length-modal'),
        type : 'inline',
        padding : 0,
        maxHeight:600,
        helpers : { 
          overlay: {
           css: { 'background': 'rgba(233, 233, 233, 0.9)'} 
          } 
       } 
      }); 
      ga('send', 'event', 'which-length-for-me', 'which-length-for-me');
    });
  
  
   // youtube vidoe detail 
    $('span.youtube-play').on('click',function(e){
        // e.preventDefault();
            let yid = $(this).data('id');
            console.log('youtube id',yid);
            youtubeHtml= '<iframe src="https://www.youtube.com/embed/'+yid+'?autoplay=1&mute=1" '
            +' frameborder="0"'
            +' allow="autoplay" '
            + ' allowfullscreen></iframe>';

            $(this).parent('div.youtube').html(youtubeHtml);
    })

});



let productRecommendations = (function() {
    function ProductRecommendations(container) {
      var $container = (this.$container = $(container));
      var baseUrl = $container.data('base-url');
      var productId = $container.data('product-id');
      var limit = $container.data('limit');
      var productRecommendationsUrlAndContainerClass = baseUrl + '?section_id=product-recommendations&limit=' + limit +
      '&product_id=' +productId ;
  
        $.ajax({
          type:"GET",
          url: productRecommendationsUrlAndContainerClass,
          success: function (data) {
            console.log('get relate product ');
            
             $('#product-recommendations').html(data);
  
  
          },
          error: function(data) {
           
          }
        });
      
    }
    return ProductRecommendations;
  })();
  
  $(document).ready(function(){
    productRecommendations('#product-recommendations');
  });